import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AuthLogo from '../components/AuthLogo';
import { UseTranslate } from '../../hooks/Translate';
import AppContext from '../../contexts/AppContext';

export const RecoverySuccess = () => {
  const { returnUrl } = useContext(AppContext);
  const navigate = useNavigate();
  const [translate] = UseTranslate();

  return (
    <div className="auth-wrapper">
      <div className="text-center">
        <AuthLogo />
      </div>
      <div className="text-center">
        <h6>{translate('cas.registration.changePswd')}</h6>
      </div>

      <div className="text-center d-flex justify-content-center mt-5">
        <div className="password-recovery-success">
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            className="bi bi-check"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
            />
          </svg>
        </div>
      </div>

      <div className="text-center mt-3 mb-4">
        <small className="text-success text-b">
          <strong>{translate('cas.registration.pswdChangeSuccess')}</strong>
        </small>
      </div>

      <Button
        type="button"
        variant="primary"
        onClick={() => returnUrl
          ? window.location.replace(returnUrl) : navigate('/login')}
        className="w-100 mt-3"
      >
        {translate('cas.registration.authorize')}
      </Button>
    </div>
  );
};
